module.exports = __webpack_public_path__ + "static/12-mission2-Img-0ff83e7eaa8a6829cf85a55eddfd674a.png";